import { useQuery } from "react-query";
import { mediaSettingsApi } from "@circle-react/api";
import type { ApiError } from "@circle-react/config/CustomErrors";
import type { MediaSetting } from "@circle-react/types/MediaSetting";

interface UseMediaSettingsOptions {
  signedId: string;
}

export const useMediaSettings = ({ signedId }: UseMediaSettingsOptions) =>
  useQuery<unknown, ApiError, MediaSetting>({
    queryKey: ["mediaSettings", signedId],
    queryFn: () => mediaSettingsApi.show(signedId),
  });
